


















import { Component, Prop, Vue } from "vue-property-decorator";
import { bus } from "@/main";
import { SubNavItem } from "@/store/types";

@Component
export default class SubmissionNav extends Vue {
  @Prop({ default: () => [] }) navItems: Array<SubNavItem>;
  @Prop({ default: "top-submission-nav" }) navId: string;
  @Prop({ default: -1 }) workIndex: number;
  @Prop({ default: true }) showSort: boolean;
  @Prop({ default: false }) showOverview: boolean;
  @Prop({ default: false }) disabled: boolean;

  get items(): Array<SubNavItem> {
    return this.navItems
      .filter((sub) => this.showSort || sub.key !== "sort")
      .map((sub) => {
        //const type = sub.key === "add_work"? "is-success is-light" : sub.active? "is-primary" : "is-light";
        let type = "is-light";
        switch (sub.key) {
          case "add_work":
          case "sort":
            type = sub.active ? "is-primary" : "is-primary is-light";
            sub.title = sub.name;
            break;
          case "start":
            type = sub.active ? "is-info" : "is-info is-light";
            break;
          case "overview":
            type = sub.active ? "is-success" : "is-success is-light";
            break;
          default:
            type = sub.active ? "is-primary" : "is-primary is-light";
            break;
        }
        const keyParts = sub.key.split("-");
        const firstClass = keyParts[0].replace(/_/g, "-");
        const classNames = [firstClass];
        switch (firstClass) {
          case "prev":
          case "next":
            classNames.push("arrow");
            sub.title = sub.name;
            sub.name = "";
            if (this.workIndex < 0 && firstClass === "prev") {
              classNames.push("inactive");
            } else if (this.showOverview && firstClass === "next") {
              classNames.push("inactive");
            }
            break;
        }

        const iconLeft = firstClass === "prev" ? sub.icon : "";
        const icon = firstClass === "prev" ? "" : sub.icon;
        return { ...sub, type, icon, iconLeft, classNames };
      });
  }

  get showNav() {
    return this.navItems.length > 1 || this.navItems.some(nv => nv.key === "start");
  }

  goTo(key: string) {
    bus.$emit("goto", key);
  }

  isDisabled(key = '') {
    return this.disabled && (['start'].includes(key) === false || this.workIndex >= 0);
  }
}
